import { useEffect } from 'react'
import Select from 'components/Inputs/Select'
import PasswordInput from 'components/Inputs/PasswordInput'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import professionalSecurityValidator from 'validators/professionalSecurityValidator'
import { MdNavigateNext } from 'react-icons/md'
import ReactTooltip from 'react-tooltip'
import { Formik } from 'formik'

import {
  Form,
  SubTitle,
  InfoText,
  FormField,
  Label,
  WarningText,
  Row
} from '../styles'

export default function SecurityForm ({
  professionalData = {},
  accessLevels = [],
  isTutorial = false,
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  return (
    <Formik
      validationSchema={professionalSecurityValidator}
      initialValues={{
        'access_level': professionalData.access_level,
        'password': professionalData.password,
        'password_confirmation': professionalData.password_confirmation
      }}
      onSubmit={values => handleFormSubmitted (values)}
    >
      {function Security ({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        handleChange,
        handleBlur,
        handleSubmit
      }) {
        useEffect (() => {
          setFieldValue ('access_level', getAccessLevel ())
        }, [])

        const filterAccessLevels = () => {
          const levels = isTutorial
            ? accessLevels.filter (level => level.codename === 'service')
            : accessLevels

          return levels.map (level => ({
            label: level.name,
            value: level
          }))
        }

        const getAccessLevel = () => {
          if (!isTutorial) return values.access_level

          const serviceLevel = accessLevels.find (level => level.codename === 'service')

          return {
            label: serviceLevel.name,
            value: serviceLevel
          }
        } 

        return (
          <Form onKeyDown={submitOnEnter(handleSubmit)} autoComplete='off' style={{width: 400}}>
            <SubTitle>Segurança</SubTitle>
            <Row>
              <FormField data-for='access_level_tip' data-tip>
                <Select
                  name='access_level'
                  placeholder='Nível de acesso...'
                  value={getAccessLevel ()}
                  options={filterAccessLevels ()}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  error={errors.access_level}
                  touched={touched.access_level}
                />
                {values.access_level && (
                  <ReactTooltip id='access_level_tip' effect='solid' backgroundColor='#252525' tooltipRadius='10'>
                    <Label style={{color: '#FFFFFF'}}>
                      {values.access_level?.value.description}
                    </Label>
                  </ReactTooltip>
                )}
                {touched.access_level && errors.access_level && (
                  <WarningText>{errors.access_level}</WarningText>
                )}
              </FormField>
            </Row>         
            <Row>
              <FormField>
                <PasswordInput
                  placeholder='Senha'
                  value={values.password}
                  onChange={handleChange ('password')}
                  onBlur={handleBlur ('password')}
                />
                {touched.password && errors.password && (
                  <WarningText>{errors.password}</WarningText>
                )}
              </FormField>
            </Row>         
            <Row>
              <FormField>
                <PasswordInput
                  placeholder='Confirmar senha'
                  value={values.password_confirmation}
                  onChange={handleChange ('password_confirmation')}
                  onBlur={handleBlur ('password_confirmation')}
                />
                {touched.password_confirmation && errors.password_confirmation && (
                  <WarningText>{errors.password_confirmation}</WarningText>
                )}
              </FormField>
            </Row>
            <Row>
              <InfoText>
                Esta senha será usada para que o(a) profissional acesse sua conta e agenda no app Cutilei Profissional.
              </InfoText>
            </Row>
            <MainButton
              leftIcon={<MdNavigateNext size={30}/>}
              aria-label='Próximo'
              onClick={handleSubmit}
              width={60}
            />
          </Form>
        )
      }}
    </Formik>
  )
}
